import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HelpCircle, ArrowRight, UserRound, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export function WhyBlocked({ kind, id, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-block">
      <button data-testid={testid} onClick={() => setOpen((o) => !o)} className="ml-1 inline-flex items-center gap-0.5 rounded-full border border-amber-300 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800 transition-colors hover:bg-amber-100"><HelpCircle className="h-3 w-3" />Why?</button>
      {open && <div className="rise absolute left-0 top-7 z-40 w-[420px] rounded-xl bg-white shadow-xl"><BlockedPanel kind={kind} id={id} compact /></div>}
    </span>
  );
}

export function BlockedPanel({ kind, id, onStatus, compact }) {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/blocked/${kind}/${id}`).then((r) => { setD(r.data); onStatus?.(r.data.status); }).catch(() => setD({ reasons: [] })), [kind, id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    load();
    const f = () => document.visibilityState === "visible" && load();
    window.addEventListener("focus", f);
    document.addEventListener("visibilitychange", f);
    return () => { window.removeEventListener("focus", f); document.removeEventListener("visibilitychange", f); };
  }, [load]);
  if (!d) return null;
  if (!d.reasons.length) return compact ? <p className="flex items-center gap-1.5 text-sm text-emerald-700" data-testid="blocked-none"><CheckCircle2 className="h-4 w-4" />Nothing is blocking this any more.</p> : null;
  return (
    <div className="rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white p-4" data-testid="blocked-panel">
      <p className="mb-2 flex items-center gap-2 text-sm font-semibold text-amber-900"><HelpCircle className="h-4 w-4" />Why is this blocked?</p>
      <ul className="space-y-2">
        {d.reasons.map((r, i) => (
          <li key={i} className="flex flex-wrap items-center gap-3 rounded-lg bg-white/80 px-3 py-2 text-sm text-slate-700 ring-1 ring-amber-100" data-testid={`blocked-reason-${i}`}>
            <span className="flex-1">{r.text}</span>
            {r.to ? <Link to={r.to} data-testid={`blocked-fix-${i}`} className="inline-flex items-center gap-1 rounded-lg bg-[#D52B3B] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#b82231]">{r.label}<ArrowRight className="h-3.5 w-3.5" /></Link>
              : <span className="inline-flex items-center gap-1 text-xs text-slate-500" data-testid={`blocked-who-${i}`}><UserRound className="h-3.5 w-3.5" />{r.who}</span>}
          </li>))}
      </ul>
    </div>
  );
}
